class GallerySliders {

  constructor() {
    this.init()
  }

    initMobilePdpGallerySlider() {
        const mobileSliderOptions = {
          arrows: false,
          pagination: false,
        } ;

        const mobileSlider = new Splide('#splide-slider', mobileSliderOptions)
        mobileSlider.mount()
    }

    initDesktopPdpGallerySlider() {        
            
        const desktopMainSliderOptions =  {
                      type       : 'fade',
                      pagination : false,
                      arrows     : false,
                      cover      : true,
                }
              
              
        const thumbnailsSliderOptions = {
                  rewind          : true,
                  fixedWidth      : 77,
                  fixedHeight     : 77,
                  isNavigation    : true,
                  gap: 10,
                  direction       : window.galleryLayout,
                  height          : 450,
                  width:            450,
                  pagination      : false,
                  dragMinThreshold: {
                    mouse: 4,
                    touch: 10,
                  },
                
            }
          
        var desktopMainSlider = new Splide('#main-slider', desktopMainSliderOptions)
        var desktopThumbnailSlider = new Splide("#thumbnail-slider", thumbnailsSliderOptions)
          
          
        desktopMainSlider.sync( desktopThumbnailSlider );
        desktopMainSlider.mount();
        desktopThumbnailSlider.mount();
    }

    handleSplideSlider() {
        const mediaModal = document.querySelector("#media-modal");

        if (mediaModal) {
            mediaModal.splideInstance = new Splide(mediaModal, {
                type: 'slide',
                perPage: 1,
                perMove: 1,
                mobileFirst: true,
                arrows: true,
                pagination: false,
                breakpoints: {
                    992: {
                        perPage: 1,
                        centerMode: true,
                        variableWidth: false,
                    },
                },
            }).mount();
        }
    }
    
    initModal() {
        this.openModal = (imageUrl) => {
            const modal = document.getElementById('media-modal');
            const modalImage = document.getElementById('modal-image');
            modalImage.src = imageUrl;
            modal.classList.add('active');
            document.body.style.overflow = 'hidden';
        };

        this.closeModal = () => {
            const modal = document.getElementById('media-modal');
            modal.classList.remove('active');
            document.body.style.overflow = 'unset';
        };

        document.querySelectorAll('.main-image-media-gallery').forEach((thumbnail) => {
            thumbnail.addEventListener('click', () => {
                const imageUrl = thumbnail.src;
                this.openModal(imageUrl);
            });
        });

        window.closeModal = this.closeModal;

        document.getElementById('media-modal').addEventListener('click', (e) => {
            if (e.target === e.currentTarget) {
                this.closeModal();
            }
        });
    }
    
    init() {
      document.addEventListener('DOMContentLoaded', () => {
            this.initMobilePdpGallerySlider()
            this.initDesktopPdpGallerySlider()
            this.initModal()
            this.handleSplideSlider()
        })
    }
       
}

let gallerySlider = new GallerySliders()
